// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/reports/collected-awards/styles.scss
// module id = 993
// module chunks = 0